'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Navigation = require('../components/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _UIApplication = require('UIComponents/app/UIApplication');

var _UIApplication2 = _interopRequireDefault(_UIApplication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavApp = function NavApp(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    _UIApplication2.default,
    { name: 'growthhub-ui' },
    _react2.default.createElement(_Navigation2.default, null),
    children
  );
};

NavApp.propTypes = {
  children: _react.PropTypes.node.isRequired
};

exports.default = NavApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/NavApp.js
// module id = 54
// module chunks = 0